import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26f00f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = { class: "field-group md:flex-row flex-column" }
const _hoisted_3 = { class: "field-group md:flex-row flex-column" }
const _hoisted_4 = { class: "field-group md:flex-row flex-column" }
const _hoisted_5 = { class: "field-group md:flex-row flex-column" }
const _hoisted_6 = { class: "field-group md:flex-row flex-column" }
const _hoisted_7 = { class: "field-group md:flex-row flex-column" }

import {
  reactive,
  ref,
  PropType,
  watch,
  computed
} from 'vue';
import { useRoute } from 'vue-router';

import { FormValidator } from '@/validators/FormValidator';
import CustomTextField from '@/components/forms/fields/CustomTextField.vue';
import CustomCalendarField from '@/components/forms/fields/CustomCalendarField.vue';
import CustomAutoComplete from '@/components/forms/fields/CustomAutoComplete.vue';
import { DoctorEntity } from '@/interfaces/DoctorEntity';


export default /*#__PURE__*/_defineComponent({
  __name: 'EntityInfo',
  props: {
  modelValue: {
    type: Object as PropType<DoctorEntity>,
    default: () => ({})
  }
},
  emits: ['update:entityFormValidationChangeState'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const route = useRoute();

const showFields = computed(() => {
  const uuidPattern =
    /^\/doctors\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidPattern.test(route.path);
});

const thisEntity = ref<DoctorEntity>(props.modelValue || ({} as DoctorEntity));
const suggestions = ref<string[]>([]);
const userInput = ref('');

const counties = [
  { simpleName: 'Alba', name: 'Alba', code: 'RO-AB' },
  { simpleName: 'Arad', name: 'Arad', code: 'RO-AR' },
  { simpleName: 'Arges', name: 'Argeș', code: 'RO-AG' },
  { simpleName: 'Bacau', name: 'Bacău', code: 'RO-BC' },
  { simpleName: 'Bihor', name: 'Bihor', code: 'RO-BH' },
  { simpleName: 'Bistrita-Nasaud', name: 'Bistrița-Năsăud', code: 'RO-BN' },
  { simpleName: 'Botosani', name: 'Botoșani', code: 'RO-BT' },
  { simpleName: 'Brasov', name: 'Brașov', code: 'RO-BV' },
  { simpleName: 'Braila', name: 'Brăila', code: 'RO-BR' },
  { simpleName: 'Buzau', name: 'Buzău', code: 'RO-BZ' },
  { simpleName: 'Caras-Severin', name: 'Caraș-Severin', code: 'RO-CS' },
  { simpleName: 'Calarasi', name: 'Călărași', code: 'RO-CL' },
  { simpleName: 'Cluj', name: 'Cluj', code: 'RO-CJ' },
  { simpleName: 'Constanta', name: 'Constanța', code: 'RO-CT' },
  { simpleName: 'Covasna', name: 'Covasna', code: 'RO-CV' },
  { simpleName: 'Dambovita', name: 'Dâmbovița', code: 'RO-DB' },
  { simpleName: 'Dolj', name: 'Dolj', code: 'RO-DJ' },
  { simpleName: 'Galati', name: 'Galați', code: 'RO-GL' },
  { simpleName: 'Giurgiu', name: 'Giurgiu', code: 'RO-GR' },
  { simpleName: 'Gorj', name: 'Gorj', code: 'RO-GJ' },
  { simpleName: 'Harghita', name: 'Harghita', code: 'RO-HR' },
  { simpleName: 'Hunedoara', name: 'Hunedoara', code: 'RO-HD' },
  { simpleName: 'Ialomita', name: 'Ialomița', code: 'RO-IL' },
  { simpleName: 'Iasi', name: 'Iași', code: 'RO-IS' },
  { simpleName: 'Ilfov', name: 'Ilfov', code: 'RO-IF' },
  { simpleName: 'Maramures', name: 'Maramureș', code: 'RO-MM' },
  { simpleName: 'Mehedinti', name: 'Mehedinți', code: 'RO-MH' },
  { simpleName: 'Mures', name: 'Mureș', code: 'RO-MS' },
  { simpleName: 'Neamt', name: 'Neamț', code: 'RO-NT' },
  { simpleName: 'Olt', name: 'Olt', code: 'RO-OT' },
  { simpleName: 'Prahova', name: 'Prahova', code: 'RO-PH' },
  { simpleName: 'Satu Mare', name: 'Satu Mare', code: 'RO-SM' },
  { simpleName: 'Salaj', name: 'Sălaj', code: 'RO-SJ' },
  { simpleName: 'Sibiu', name: 'Sibiu', code: 'RO-SB' },
  { simpleName: 'Suceava', name: 'Suceava', code: 'RO-SV' },
  { simpleName: 'Teleorman', name: 'Teleorman', code: 'RO-TR' },
  { simpleName: 'Timis', name: 'Timiș', code: 'RO-TM' },
  { simpleName: 'Tulcea', name: 'Tulcea', code: 'RO-TL' },
  { simpleName: 'Vaslui', name: 'Vaslui', code: 'RO-VS' },
  { simpleName: 'Valcea', name: 'Vâlcea', code: 'RO-VL' },
  { simpleName: 'Vrancea', name: 'Vrancea', code: 'RO-VN' },
  { simpleName: 'Sector 1 (Bucuresti)', name: 'Sector 1', code: 'RO-B' },
  { simpleName: 'Sector 2 (Bucuresti)', name: 'Sector 2', code: 'RO-B' },
  { simpleName: 'Sector 3 (Bucuresti)', name: 'Sector 3', code: 'RO-B' },
  { simpleName: 'Sector 4 (Bucuresti)', name: 'Sector 4', code: 'RO-B' },
  { simpleName: 'Sector 5 (Bucuresti)', name: 'Sector 5', code: 'RO-B' },
  { simpleName: 'Sector 6 (Bucuresti)', name: 'Sector 6', code: 'RO-B' }
];

const searchCounty = (event: { query: string }) => {
  const queryString = event.query.replace(/ș/g, 's').replace(/Ș/g, 'S');
  const results = counties.filter((county) =>
    county.simpleName
      .toLocaleLowerCase()
      .includes(queryString.toLocaleLowerCase())
  );
  suggestions.value = results.map((county) => {
    if (county.name.includes('Sector')) {
      return county.name + ' (București)';
    } else {
      return county.name;
    }
  });
};

const changeCounty = (event) => {
  if (isValidCounty(event.value)) {
    if (
      event.value.replace(/ș/g, 's').replace(/Ș/g, 'S').includes(' (Bucuresti)')
    ) {
      thisEntity.value.entityCity = event.value
        .replace(/ș/g, 's')
        .replace(/Ș/g, 'S')
        .replace(' (Bucuresti)', '')
        .replace(/\s+/g, '')
        .toUpperCase();
      thisEntity.value.entityCounty = 'București';
    }
  }
};

const isValidCounty = (input: string) => {
  input = input.replace(/ș/g, 's').replace(/Ș/g, 'S');
  const results = counties.filter(
    (county) =>
      county.name.toLocaleLowerCase() === input.toLocaleLowerCase() ||
      county.simpleName.toLocaleLowerCase().includes(input.toLocaleLowerCase())
  );
  if (
    results.length == 1 ||
    (results.length == 6 && results[0].code === 'RO-B')
  ) {
    thisEntity.value.entityCountyCode = results[0].code;
    return true;
  } else {
    return false;
  }
};

const isInvalid = reactive({
  entityBank: false,
  entityCui: false,
  entityIban: false,
  entityName: false,
  entityCounty: false,
  entityCity: false,
  entityStreet: false,
  identityCard: false,
  invoiceSerial: false,
  invoiceCurrentNumber: false,
  contractNumber: false,
  contractDate: false
});

const onFieldChangeValidation = ({
  fieldName,
  isValid
}: {
  fieldName: string;
  isValid: boolean;
}) => {
  isInvalid[fieldName] = !isValid;
};

const isValidForm = computed(() => {
  return Object.values(isInvalid).every((value) => value === false);
});

watch(isValidForm, (newValue) => {
  emit('update:entityFormValidationChangeState', newValue);
});

watch(
  () => thisEntity.value.entityName,
  (newName) => {
    if (newName) {
      const words = newName.split(' ');
      let serial = '';

      if (words.length === 1) {
        serial = words[0].substr(0, 4).toLocaleUpperCase();
      } else if (words.length === 2) {
        serial =
          words[0].substr(0, 2).toLocaleUpperCase() +
          words[1].substr(0, 2).toLocaleUpperCase();
      } else if (words.length >= 3) {
        serial =
          words[0].substr(0, 2).toLocaleUpperCase() +
          words[1].substr(0, 1).toLocaleUpperCase() +
          words[2].substr(0, 1).toLocaleUpperCase();
      }

      thisEntity.value.invoiceSerial = `DR${serial}`;
    }
  }
);

watch(
  () => props.modelValue,
  (newValue) => {
    thisEntity.value = newValue;
  }
);

setTimeout(() => {
  emit('update:entityFormValidationChangeState', isValidForm);
}, 1);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CustomTextField, {
        id: "entityBank",
        modelValue: thisEntity.value.entityBank,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((thisEntity.value.entityBank) = $event)),
        placeholder: "Bancă",
        iconClass: "pi pi-briefcase",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "entityIban",
        modelValue: thisEntity.value.entityIban,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((thisEntity.value.entityIban) = $event)),
        placeholder: "IBAN",
        iconClass: "pi pi-wallet",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CustomTextField, {
        id: "entityName",
        modelValue: thisEntity.value.entityName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((thisEntity.value.entityName) = $event)),
        placeholder: "Nume entitate",
        iconClass: "pi pi-briefcase",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomAutoComplete, {
        id: "entityCounty",
        modelValue: thisEntity.value.entityCounty,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((thisEntity.value.entityCounty) = $event)),
        placeholder: "Județ",
        iconClass: "pi pi-map-marker",
        options: suggestions.value,
        search: searchCounty,
        change: changeCounty,
        validators: [_unref(FormValidator).isPresent, isValidCounty],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "options", "validators"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CustomTextField, {
        id: "entityCity",
        modelValue: thisEntity.value.entityCity,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((thisEntity.value.entityCity) = $event)),
        placeholder: "Localitate",
        iconClass: "pi pi-map-marker",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "entityCounty",
        modelValue: thisEntity.value.entityStreet,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((thisEntity.value.entityStreet) = $event)),
        placeholder: "Adresă",
        iconClass: "pi pi-map-marker",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(CustomTextField, {
        id: "entityCui",
        modelValue: thisEntity.value.entityCui,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((thisEntity.value.entityCui) = $event)),
        placeholder: "CUI",
        iconClass: "pi pi-globe",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "identityCard",
        modelValue: thisEntity.value.identityCard,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((thisEntity.value.identityCard) = $event)),
        placeholder: "Carte de identitate",
        iconClass: "pi pi-book",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(CustomTextField, {
        id: "invoiceSerial",
        modelValue: thisEntity.value.invoiceSerial,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((thisEntity.value.invoiceSerial) = $event)),
        placeholder: "Serie factură",
        iconClass: "pi pi-copy",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomCalendarField, {
        id: "contractDate",
        modelValue: thisEntity.value.contractDate,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((thisEntity.value.contractDate) = $event)),
        placeholder: "Data contract DoctorApp",
        iconClass: "pi pi-copy",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(CustomTextField, {
        id: "invoiceCurrentNumber",
        modelValue: thisEntity.value.invoiceCurrentNumber,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((thisEntity.value.invoiceCurrentNumber) = $event)),
        placeholder: "Număr factură",
        iconClass: "pi pi-copy",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"]),
      _createVNode(CustomTextField, {
        id: "contractNumber",
        modelValue: thisEntity.value.contractNumber,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((thisEntity.value.contractNumber) = $event)),
        placeholder: "Număr contract DoctorApp",
        iconClass: "pi pi-copy",
        validators: [_unref(FormValidator).isPresent],
        validationMessage: "Acest câmp este obligatoriu",
        "onUpdate:isValid": onFieldChangeValidation
      }, null, 8, ["modelValue", "validators"])
    ])
  ]))
}
}

})